import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { Star } from "./Logo";
import { useLang } from "@/i18n/LanguageContext";

export default function B2BTeaser() {
  const { t, lang } = useLang();

  return (
    <section id="boutiquen" className="py-24 sm:py-32" style={{ background: "var(--surface-secondary)" }} data-testid="b2b-teaser-section">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 sm:px-8 lg:grid-cols-2 lg:items-center lg:gap-20">
        <Reveal>
          <p className="flex items-center gap-2 text-xs uppercase font-medium" style={{ color: "var(--camel)", letterSpacing: "0.16em" }}>
            <Star size={11} /> {t.b2b.kicker}
          </p>
          <h2 className="mt-5 font-serif-display text-4xl sm:text-5xl font-semibold leading-tight" data-testid="b2b-teaser-title">
            {t.b2b.title}
          </h2>
          <p className="mt-5 max-w-md text-base md:text-lg leading-relaxed" style={{ color: "var(--muted-warm)" }}>
            {t.b2b.sub}
          </p>
          <ul className="mt-8 space-y-3.5">
            {t.b2b.bullets.slice(0, 3).map((b, i) => (
              <li key={i} className="flex items-start gap-3 text-sm sm:text-base" data-testid={`b2b-teaser-bullet-${i + 1}`}>
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full" style={{ background: "var(--rose-soft)" }}>
                  <Check size={13} style={{ color: "var(--camel)" }} />
                </span>
                <span style={{ color: "var(--on-surface)" }}>{b}</span>
              </li>
            ))}
          </ul>
          <Link
            to="/business"
            data-testid="b2b-teaser-cta"
            className="pill-btn mt-10 inline-flex items-center gap-2 rounded-full px-8 py-4 text-sm font-medium text-white"
            style={{ background: "var(--camel)" }}
          >
            {t.b2bPage.teaserCta} <ArrowRight size={15} />
          </Link>
        </Reveal>
        <Reveal delay={0.15} className="flex justify-center">
          <div className="w-64 sm:w-72 overflow-hidden rounded-[2rem] border-[6px] shadow-[0_40px_80px_-40px_rgba(198,156,109,0.5)]" style={{ borderColor: "#262119", background: "#262119" }}>
            <img src={`/app-screens/${lang}/kiosk.webp?v=5`} alt={t.b2b.title} className="w-full rounded-[1.6rem]" loading="lazy" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
